import { ASSESSMENT_POSTERIOR } from '../constants';
import type { AssessmentPosteriorType } from '../types';

export function createAssessmentPrior(): AssessmentPosteriorType {
  const scores = Array.from(
    { length: ASSESSMENT_POSTERIOR.maximumScore - ASSESSMENT_POSTERIOR.minimumScore + 1 },
    (_, index) => ASSESSMENT_POSTERIOR.minimumScore + index,
  );
  const weights = scores.map((ability) => {
    const standardized =
      (ability - ASSESSMENT_POSTERIOR.priorMean) / ASSESSMENT_POSTERIOR.priorStandardDeviation;
    return Math.exp(-0.5 * standardized ** 2);
  });
  const centerIndex = scores.indexOf(ASSESSMENT_POSTERIOR.priorMean);
  const centerWeight = weights[centerIndex] ?? 0;
  const leftWeight = weights.slice(0, centerIndex).reduce((sum, weight) => sum + weight, 0);
  const rightWeight = weights.slice(centerIndex + 1).reduce((sum, weight) => sum + weight, 0);
  const sideTargetWeight = (leftWeight + rightWeight) / 2;
  const centeredWeights = weights.map((weight, index) => {
    if (index < centerIndex) {
      return weight * (sideTargetWeight / leftWeight);
    }
    if (index > centerIndex) {
      return weight * (sideTargetWeight / rightWeight);
    }
    return centerWeight;
  });
  const totalWeight = centeredWeights.reduce((sum, weight) => sum + weight, 0);
  return Object.freeze(
    scores.map((ability, index) =>
      Object.freeze({ ability, probability: (centeredWeights[index] ?? 0) / totalWeight }),
    ),
  );
}
